<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Chấm công" :link="[{ text: 'Chấm công', href: '../teacher-attendances' }]" />
      </div>
    </div>
    <v-tabs class="mx-md-4" v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab v-for="item in displayedTabs" :key="item" class="tab-default">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-card outlined class="mx-md-4 elevation-0">
      <v-tabs-items v-model="tab" v-if="displayedTabs.length > 0">
        <v-tab-item v-if="displayedTabs.includes('Ra vào')" :key="1">
          <Attendances />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import Attendances from '../teacher-attendance/TeacherAttendances.vue'

export default {
  components: { Breadcrumbs, Attendances },
  data: () => ({tab: null}),
  computed: {
    displayedTabs() {
      const tabs = []
      if (this.$auth.policies['view-teacher-attendance-list']) {
        tabs.push('Ra vào')
      }
      return tabs
    },
  },
  created() {
    if (this.$route.query.diligence) {
      this.tab = 1
    } else if (this.displayedTabs.length > 0) {
      this.tab = 0
    }
  },
}
</script>
